import pagination from "../../utils/pagination";
import {
    ROLES_BATCH_DELETE_REQUEST,
    ROLES_BATCH_DELETE_SUCCESS,
    ROLES_BATCH_DELETE_FAILURE,
    ROLES_FETCH_MANY_REQUEST,
    ROLES_FETCH_MANY_SUCCESS,
    ROLES_FETCH_MANY_FAILURE,
    ROLES_FETCH_REQUEST,
    ROLES_FETCH_SUCCESS,
    ROLES_FETCH_FAILURE,
    ROLES_SAVE_REQUEST,
    ROLES_SAVE_SUCCESS,
    ROLES_SAVE_FAILURE,
    EMPTY_ROLES,
    CLEAR_ERRORS
} from "./types";

export default {
    [ROLES_BATCH_DELETE_REQUEST](state) {
        state.deleting = true;
    },
    [ROLES_BATCH_DELETE_SUCCESS](state) {
        state.deleting = false;
    },
    [ROLES_BATCH_DELETE_FAILURE](state) {
        state.deleting = false;
    },
    [ROLES_FETCH_MANY_REQUEST](state) {
        state.data = [];
        state.loading = true;
    },
    [ROLES_FETCH_MANY_SUCCESS](state, { data }) {
        state.data = data.data;
        state.page = pagination(data);
        state.loading = false;
    },
    [ROLES_FETCH_MANY_FAILURE](state, { validationErrors }) {
        state.validationErrors = validationErrors || {};
        state.loading = false;
    },
    [ROLES_FETCH_REQUEST](state) {
        state.single = {};
        state.loading = true;
    },
    [ROLES_FETCH_SUCCESS](state, { data }) {
        state.single = data;
        state.loading = false;
    },
    [ROLES_FETCH_FAILURE](state) {
        state.loading = false;
    },
    [ROLES_SAVE_REQUEST](state) {
        state.data = [];
        state.saving = true;
    },
    [ROLES_SAVE_SUCCESS](state) {
        state.saving = false;
    },
    [ROLES_SAVE_FAILURE](state, { validationErrors }) {
        state.validationErrors = validationErrors || {};
        state.saving = false;
    },
    [EMPTY_ROLES](state) {
        state.data = [];
        state.loading = false;
        state.saving = false;
    },
    [CLEAR_ERRORS](state) {
        state.validationErrors = [];
        state.loading = false;
        state.saving = false;
    }
};
